<template>
	<page>
		<c-tab-list ref="tabList" class="factory-tab" :tabs="tabList" :immediate="false" type="border-tab" @change="tabHandle"></c-tab-list>
		
		<div class="factory" :class="{'flex-grow': currentTab != 1}">
			<div v-if="currentTab==1">
				<div class="flex-center-cross">
					<div class="factory-logo">
						<div class="flex-center factory-logo-image">
							<img :src="dataInfo.saas_logo || require('@/assets/image/icon.png')">
							<div v-if="auth('b_factory_name')" class="factory-logo-handle flex-center">
								<a @click="editLogoHandle()"><i class="tf">&#xe618;</i></a>
								<a v-if="dataInfo.saas_logo" @click="editLogoHandle(true)"><i class="tf-trash"></i></a>
							</div>
						</div>
						<p class="factory-logo-name flex-center">
							<span>工厂LOGO</span>
							<c-tooltip tip="建议尺寸：180X100像素"></c-tooltip>
						</p>
					</div>
					<div>
						<div class="flex-center-cross factory-name">
							<template v-if="editName !== false">
								<input v-model="editName" maxlength="14">
								<c-button color="main" @click="editNameHandle">确定</c-button>
								<c-button @click="editName = false">取消</c-button>
							</template>
							<template v-else>
								<p>{{dataInfo.saas_name}}</p>
								<a v-if="auth('b_factory_name')" @click="editName = dataInfo.saas_name"><i class="tf">&#xe618;</i></a>
							</template>
						</div>
						<div class="factory-code">工厂代码：{{dataInfo.saas_id}}</div>
					</div>
				</div>
				<table class="factory-info">
					<tr>
						<td>系统版本：</td>
						<td>
							<div class="flex-center-cross">
								<div v-if="freeEdition" class="edition" style="background: #0D6EFE;">免费版</div>
								<div v-else class="edition" style="background: #9F5A16;">专业版</div>
								<c-link v-if="freeEdition" @click="navigateTo('/upgrade')">前往升级</c-link>
							</div>
						</td>
					</tr>
					<tr>
						<td>到期时间：</td>
						<td>
							<div class="flex-center-cross">
								<span>{{dataInfo.auth_exp_date}}</span>
								<div class="tag">剩余<span>{{dataInfo.remaining_effective_days}}</span>天</div>
								<c-button v-if="!freeEdition" color="main" @click="renewalHandle">我要续期</c-button>
								<c-button v-else-if="dataInfo.remaining_effective_days <= 30" color="main" @click="renewalHandle">免费续期</c-button>
								<c-button v-else color="main" @click="renewalHandle" disabled>
									<span style="margin-right: 5px;">免费续期</span>
									<c-tooltip tip="温馨提示：您的工厂账号仍在有效期内，可在到期前30天内点此按钮免费续期，避免后期遗忘影响使用！" width="240"></c-tooltip>
								</c-button>
							</div>
						</td>
					</tr>
					<tr>
						<td>云环境：</td>
						<td>{{dataInfo.cloud_environment}}</td>
					</tr>
					<tr>
						<td>员工账号可用数：</td>
						<td>{{dataInfo.use_account_count}} / {{dataInfo.account_count}}</td>
					</tr>
					<tr v-if="saasInfo.max_v_account_count>0">
						<td>虚拟账号可用数：</td>
						<td>{{dataInfo.v_use_account_count}} / {{dataInfo.v_account_count}}</td>
					</tr>
					<tr>
						<td>软件产品名称：</td>
						<td>{{dataInfo.system_name}}</td>
					</tr>
					<!-- <tr>
						<td>文件存储空间：</td>
						<td>
							<c-progress :rate="[dataInfo.used_storage_capacity, saasInfo.max_storage_capacity * 1024 * 1024]">
								<template #text="{rate}">
									<span>{{rate.toFixed(1)}}% ({{parseByte(dataInfo.used_storage_capacity, 1)}} / {{parseByte(saasInfo.max_storage_capacity * 1024 * 1024, 1)}})</span>
								</template>
							</c-progress>
						</td>
					</tr> -->
				</table>
				<div class="factory-handle flex">
					<!-- <c-button v-if="auth('b_factory_apply_data')" v-lock="lock('b_factory_apply_data')" size="form" color="main" hollow @click="showTemplet">查看行业方案</c-button> -->
					<c-button v-if="auth('b_factory_clear_data')" v-lock="lock('b_factory_clear_data')" size="form" color="red" hollow @click="clearData">清空工厂数据</c-button>
				</div>
			</div>

			<div v-if="currentTab==2">
				<c-form unit-width="100%" ref="systemConfigForm" >
					<c-form-item label="移动端优先打开方式" tip="开启微信小程序优先打开模式，扫码二维码、点击通知链接均直接进入微信小程序，使用更便捷">
						<div class="flex-center-cross">
							<c-radio-group v-model="mobile_type" name="mobile_type" :options="mobileTypeDic" :disabled="!auth('b_factory_notice_edit')"></c-radio-group>
						</div>
					</c-form-item>
					
					<c-title>订单相关</c-title>
					<c-form-item label="订单自动占用库存" tip="新创建的订单默认库存占用状态为已占用">
						<c-radio-group v-model="order_occ_start_auto" name="order_occ_start_auto" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="订单自动完成" tip="当订单交货数>=已下单数时，订单状态变更为『已完成』">
						<c-radio-group v-model="order_end_auto" name="order_end_auto" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="订单默认发货数量" tip="按订单发货时，默认的发货数量填入规则，当考虑库存时，发货数不超过产品在库库存数">
						<c-radio-group v-model="order_default_deliver_count_type" name="order_default_deliver_count_type" :options="[{name: '不考虑库存，直接按订单未发货数填入',value: '0'},{name: '按订单未发货数并考虑库存填入',value: 1}]" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>

                    <c-title>采购相关</c-title>

                    <c-form-item label="采购单自动完成" tip="当采购单收货数>=采购数时，采购单状态变更为『已完成』">
                        <c-radio-group v-model="purchase_order_end_auto" name="purchase_order_end_auto" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
                    </c-form-item>

					
					<c-title>工单相关</c-title>
					<c-form-item label="新工单自动开始" tip="新创建的工单默认为执行状态">
						<c-radio-group v-model="work_start_auto" name="work_start_auto" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="工单自动结束" tip="当工单完工数>=工单计划数时，工单状态变更为『已结束』">
						<c-radio-group v-model="work_end_auto" name="work_end_auto" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="限制工单领料数量" tip="移动端工单在领料时，最大可领料数不允许超过物料的预计用量数">
						<c-radio-group v-model="work_material_picking_limit" name="work_material_picking_limit" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="按报工权限领料" tip="移动端工单在领料时，只有拥有该工序的报工权限时,才允许领取对应工序投料的物料">
						<c-radio-group v-model="work_material_by_output_auth" name="work_material_by_output_auth" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					
					<c-title>任务工序相关</c-title>
					<c-form-item label="任务自动开始" tip="工单开始执行后，相关工序任务同步开始">
						<c-radio-group v-model="task_start_auto" name="task_start_auto" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="任务自动结束" tip="当任务良品数>=任务计划数时，任务状态变更为『已结束』">
						<c-radio-group v-model="task_end_auto" name="task_end_auto" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="外发发料方式" tip="任务外发后,前往委外单手动发料还是委外单生成的同时自动生成委外动态">
						<c-radio-group v-model="material_process_method" name="material_process_method" :options="materialProcessMethodDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					
					<c-title>报工相关</c-title>
					<c-form-item label="限制报工数量" tip="限制工序报工数量/良品数不能大于计划数量">
						<c-radio-group v-model="output_count_limit" name="output_count_limit" :options="outputCountLimitTypeDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="按分配数报工" tip="开启后，如果分配数>0时，则按员工限制工序报工数量不能大于员工分配数量">
						<c-radio-group v-model="distribute_count_limit" name="distribute_count_limit" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="限制报工顺序" tip="开启后，生产报工数量不得超过上一组工序的最小良品数量；如需工序并行报工，可在工单创建时配置工序为 “与前工序同时”。关闭后，工序无顺序依赖，可独立报工。">
						<c-radio-group v-model="output_sort" name="output_sort" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="报工权限分配优先" tip="存在分配人员，则只能分配人员进行报工">
						<c-radio-group v-model="distribute_auth_priority" name="distribute_auth_priority" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="限制装配工单顺序" tip="子装配工单未完成，不允许父装配工单报工">
						<c-radio-group v-model="assemble_work_sort" name="assemble_work_sort" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="报工自动入库时间" tip="当工单任务开启[自动入库]配置时，员工报工后立即生成入库单,还是需要在报工记录审批后生成入库单">
						<c-radio-group v-model="auto_in_time_type" name="auto_in_time_type" :options="autoInTimeTypeDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="不良品计算工资" tip="开启后，预计工资=(良品数+不良品数)*工资单价，否则预计工资=良品数*工资单价">
						<c-radio-group v-model="defects_salary" name="defects_salary" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					
					<c-title>单据审批</c-title>
					<c-form-item label="【订单发货】自动核准" tip="开启后，【订单发货】状态自动为核准状态，自动生成关联出库单">
						<c-radio-group v-model="order_deliver_auto_approval" name="order_deliver_auto_approval" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="【生产入库检】自动审批" tip="开启后，【生产入库检】自动完成审批，如果质检单开启了合格品自动入库，则自动生成关联入库单">
						<c-radio-group v-model="quality_work_auto_approval" name="quality_work_auto_approval" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="【入库单】自动审批" tip="开启后，【入库单】自动完成审批，相关产品库存数据直接变更">
						<c-radio-group v-model="stockin_auto_approval" name="stockin_auto_approval" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="【出库单】自动审批" tip="开启后，【出库单】自动完成审批，相关产品库存数据直接变更">
						<c-radio-group v-model="stockout_auto_approval" name="stockout_auto_approval" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="【盘点单】自动审批" tip="开启后，【盘点单】自动完成审批，相关产品库存数据直接变更">
						<c-radio-group v-model="inventory_auto_approval" name="inventory_auto_approval" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					<c-form-item label="【报工记录】自动审批" tip="开启后，【报工记录】自动完成审批">
						<c-radio-group v-model="output_auto_approval" name="output_auto_approval" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>
					
					<c-title>其他</c-title>
					<c-form-item label="校验库存是否充足" tip="开启后，当库存不足时，无法完成库存扣减操作">
						<div class="flex-center-cross">
							<c-radio-group v-model="check_stock" name="check_stock" :options="openCloseDic" :disabled="!auth('b_factory_notice_edit')"></c-radio-group>
						</div>
					</c-form-item>

					<div class="factory-handle flex">
						<c-button v-if="auth('b_factory_system_edit')" v-lock="lock('b_factory_system_edit')" size="form" color="main" hollow @click="submitSystemConfig">保存配置</c-button>
					</div>
				</c-form>
			</div>

			<div v-if="currentTab==3" class="flex">
				<c-form class="flex-grow" unit-width="100%" ref="noticeConfigForm" style="max-width: 750px;">
					
					<c-title>报工相关通知</c-title>
					
					<c-form-item label="工单开始通知" tip="开启后，工单开始时会通知拥有工单第一道工序报工权限的管理员或分配人员">
						<div class="flex-center-cross">
							<c-radio-group v-model="work_start_notice" name="work_start_notice" :options="openCloseDic" :disabled="!auth('b_factory_notice_edit')"></c-radio-group>
							<c-tooltip class="notice-temp-tip" color="white" position="right">
								<c-link color="main">查看消息模板</c-link>
								<template #tip>
									<img class="notice-temp" src="@/assets/image/guide/notice_工单开始.jpg" alt="">
								</template>
							</c-tooltip>
						</div>
					</c-form-item>
					
					<c-form-item label="报工处理通知" tip="开启后，工序任务报工后，将通知拥有当前任务报工权限的管理员">
						<div class="flex-center-cross">
							<c-radio-group v-model="curr_output_notice" name="curr_output_notice" :options="openCloseDic" :disabled="!auth('b_factory_notice_edit')"></c-radio-group>
							<c-tooltip class="notice-temp-tip" color="white" position="right">
								<c-link color="main">查看消息模板</c-link>
								<template #tip>
									<img class="notice-temp" src="@/assets/image/guide/notice_报工处理.jpg" alt="">
								</template>
							</c-tooltip>
						</div>
					</c-form-item>
					
					<c-form-item label="前工序完工通知" tip="开启后，前工序任务报工后，通知拥有下一道工序报工权限的管理员或分配人员">
						<div class="flex-center-cross">
							<c-radio-group v-model="next_output_notice" name="next_output_notice" :options="openCloseDic" :disabled="!auth('b_factory_notice_edit')"></c-radio-group>
							<c-tooltip class="notice-temp-tip" color="white" position="right">
								<c-link color="main">查看消息模板</c-link>
								<template #tip>
									<img class="notice-temp" src="@/assets/image/guide/notice_前置工序完工.jpg" alt="">
								</template>
							</c-tooltip>
						</div>
					</c-form-item>
					
					<c-title>工单逾期通知</c-title>

                    <c-form-item label="状态" tip="开启后，对于未结束且未逾期工单，将提给工单创建人发送公众号消息，通知次数以及时间请自行设置">
						<div class="flex-center-cross">
							<c-radio-group v-model="work_overdue_notice" name="work_overdue_notice" :options="openCloseDic" :disabled="!auth('b_factory_notice_edit')"></c-radio-group>
							<c-tooltip class="notice-temp-tip" color="white" position="right">
								<c-link color="main">查看消息模板</c-link>
								<template #tip>
                                    <img class="notice-temp" src="@/assets/image/guide/notice_工单逾期.jpg" alt="">
								</template>
							</c-tooltip>
						</div>
					</c-form-item>

					<c-form-item v-for="(item, i) in work_overdue_notice_time_list" :key="`w${i}`" v-show="work_overdue_notice==1" :label="'第'+(i+1)+'次通知'" width="300" required>
						<c-input type="stepper" v-model="work_overdue_notice_time_list[i]" decimal="0" :range="[0,99]" step="1" step-controls="side" prepend-text="前" append-text="小时" :disabled="!auth('b_factory_notice_edit')" required></c-input>
						<template #handle v-if="work_overdue_notice_time_list.length > 1 && auth('b_factory_notice_edit')">
							<a class="notice-delete" @click="work_overdue_notice_time_list.splice(i, 1)"><i class="tf-trash"></i></a>
						</template>
					</c-form-item>

					<c-form-item v-show="work_overdue_notice==1" v-if="auth('b_factory_notice_edit')">
						<c-button size="normal" color="lesser" prepend-icon="tf-plus" hollow style="margin-right: 10px;" @click="addNoticeConfig(1)">添加</c-button>
						<c-tooltip tip="点击添加按钮可以添加一个工单逾期通知配置，设定逾期前几个小时发送通知" position="top"></c-tooltip>
					</c-form-item>

					<c-title>任务逾期通知</c-title>
                    <c-form-item label="状态" tip="开启后，对于未完成且未逾期任务，将提前给有权报工管理员或被分配人员发送公众号消息，通知次数以及时间请自行设置">
						<div class="flex-center-cross">
							<c-radio-group v-model="task_overdue_notice" name="task_overdue_notice" :options="openCloseDic" :disabled="!auth('b_factory_notice_edit')"></c-radio-group>
							<c-tooltip class="notice-temp-tip" color="white" position="right" align="end">
								<c-link color="main">查看消息模板</c-link>
								<template #tip>
                                    <img class="notice-temp" src="@/assets/image/guide/notice_任务逾期_new.jpg" alt="">
								</template>
							</c-tooltip>
						</div>
					</c-form-item>

					<c-form-item v-for="(item, i) in task_overdue_notice_time_list" :key="`t${i}`" v-show="task_overdue_notice==1" :label="'第'+(i+1)+'次通知'" width="300" required>
						<c-input type="stepper" v-model="task_overdue_notice_time_list[i]" decimal="0" :range="[0,99]" step="1" step-controls="side" prepend-text="前" append-text="小时" :disabled="!auth('b_factory_notice_edit')"></c-input>
						<template #handle v-if="task_overdue_notice_time_list.length > 1 && auth('b_factory_notice_edit')">
							<a class="notice-delete" @click="task_overdue_notice_time_list.splice(i, 1)"><i class="tf-trash"></i></a>
						</template>
					</c-form-item>

					<c-form-item v-show="task_overdue_notice==1" v-if="auth('b_factory_notice_edit')">
						<c-button size="normal" color="lesser" prepend-icon="tf-plus" hollow style="margin-right: 10px;" @click="addNoticeConfig(2)">添加</c-button>
						<c-tooltip tip="点击添加按钮可以添加一个任务逾期通知配置，设定逾期前几个小时发送通知" position="top"></c-tooltip>
					</c-form-item>

					<c-title>库存预警通知</c-title>

					<c-form-item label="状态" tip="开启库存预警通知后，仓库商品库存不足或者库存超限，将给相应的仓库管理员发送微信公众号通知，每日早8点发送警告通知，每天最多通知一次">
						<div class="flex-center-cross">
							<c-radio-group v-model="inventory_warning_notice" name="inventory_warning_notice" :options="openCloseDic" :disabled="!auth('b_factory_notice_edit')"></c-radio-group>
							<c-tooltip class="notice-temp-tip" color="white" position="right" align="end">
								<c-link color="main">查看消息模板</c-link>
								<template #tip>
									<img class="notice-temp" src="@/assets/image/guide/notice_库存预警.jpg" alt="">
								</template>
							</c-tooltip>
						</div>
					</c-form-item>

					<div class="factory-handle flex">
						<c-button v-if="auth('b_factory_notice_edit')" v-lock="lock('b_factory_notice_edit')" size="form" color="main" hollow @click="submitNoticeConfig">保存配置</c-button>
					</div>
				</c-form>
				<div class="notice-guide">
					<p class="notice-guide-tip">注：开启消息通知之前，请先完成以下两步操作，如已操作请忽略</p>
					<div class="flex">
						<div class="notice-guide-item">
							<img src="@/assets/image/guide/notice_code_1.jpg" alt="">
							<p>1. 关注凯信脚轮公众号</p>
							<span>微信扫一扫，通知是以微信公众号消息的形式发送</span>
						</div>
						<div class="notice-guide-arrow"></div>
						<div class="notice-guide-item">
							<img v-if="systemConfig.mobile_type == 2" src="@/assets/image/mp_code.jpg" alt="">
							<img v-else src="@/assets/image/guide/notice_code_2.jpg" alt="">
							<p>2. 登录手机端，即可接收消息</p>
							<span>请使用微信扫一扫，也可以点击公众号下方手机端菜单进入</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<c-dialog ref="templetList" title="行业方案" width="1000" height="650" :close-button="saasInfo.use_template_state != 2" :button="saasInfo.use_template_state == 2">
			<div class="templet-list flex-wrap">
				<div v-for="(item, i) in templetList" :key="i" class="item flex-column">
					<div class="cover">
						<div class="image" :style="{'background-image': `url('${item.template_img}')`}"></div>
					</div>
					<div class="info flex-grow-auto">
						<h5>{{item.saas_name}}</h5>
						<ul>
							<li v-for="(text, j) in item.template_sub_title" :key="j">
								<i class="tf">&#xe62b;</i>
								<p>{{text}}</p>
							</li>
						</ul>
					</div>
					<div class="button flex-center">
						<c-button color="main" @click="templetHandle(item)">应用此方案</c-button>
					</div>
				</div>
			</div>

			<template #button>
				<c-button size="dialog" color="main" @click="templetHandle()">跳过，直接进入系统</c-button>
			</template>
		</c-dialog>

		<c-dialog ref="applyType" title="选择加载数据范围" width="600px" @resolve="applyHandle">
			<ul class="data-type flex-column">
				<li v-for="(item, i) in applyType" :key="i" :class="{'z-crt': currentApplyType == item.value}" @click="currentApplyType = item.value">
					<h5>{{item.name}}</h5>
					<p>{{item.explain}}</p>
				</li>
			</ul>
		</c-dialog>

		<c-dialog ref="clearType" title="清空数据" width="600px" @resolve="clearHandle">
			<ul class="data-type flex-column">
				<li v-for="(item, i) in clearType" :key="i" :class="{'z-crt': currentClearType == item.value}" @click="currentClearType = item.value">
					<h5>{{item.name}}</h5>
					<p>{{item.explain}}</p>
				</li>
			</ul>
		</c-dialog>

		<renew-confirm v-if="freeEdition" ref="renewConfirm" @resolve="update"></renew-confirm>
	</page>
</template>

<script>
	import renewConfirm from '@/components/service/renew_confirm'
	import {mapState, mapGetters} from 'vuex'
	
	export default {
		components: {
			renewConfirm
		},

		data() {
			return {
				currentTab: 1,
				dataInfo: {},
				editName: false,

				templetList: [],

				applyType: [{
					name: '业务配置 + 基础数据 + 业务数据',
					explain: '加载所有数据，包括工单、任务、报工、出入库等业务数据，以及业务配置和基础数据',
					value: 3
				}, {
					name: '业务配置 + 基础数据',
					explain: '加载产品、工序等基础数据，以及视图配置、绩效配置方案等业务配置',
					value: 2
				}, {
					name: '仅应用业务配置',
					explain: '加载视图配置、绩效配置方案等业务配置',
					value: 1
				}],
				currentApplyType: 0,

				clearType: [{
					name: '清空业务数据',
					explain: '清空工单、任务、报工、出入库等业务数据，保留基础数据和业务配置',
					value: 1
				// }, {
				// 	name: '清空业务数据 + 基础数据',
				// 	explain: '清空工单、任务、报工、出入库等业务数据，以及产品、工序等基础数据，仅保留业务配置',
				// 	value: 2
				// }, {
				// 	name: '清空所有数据',
				// 	explain: '清空除用户账号之外的所有数据，包括所有的业务数据、基础数据和业务配置',
				// 	value: 3
				}],
				currentClearType: 0,
				
				order_occ_start_auto: 0,//是否开启【订单自动占用库存】1=开启 0=关闭
				order_end_auto: 1,		//是否开启【订单自动完成】1=开启 0=关闭
                purchase_order_end_auto: 1,		//是否开启【采购单自动完成】1=开启 0=关闭
				order_default_deliver_count_type: 0,	//订单默认发货数量填入规则，按订单发货时，默认的发货数量填入规则，当考虑库存时，发货数不超过产品在库库存数
				work_start_auto: 0,		//是否开启【工单状态自动开始】1=开启 0=关闭
				work_end_auto: 1,		//是否开启【工单状态自动结束】1=开启 0=关闭
				work_material_picking_limit: 1, //是否开启【是否限制工单领料数量】1=开启 0=关闭
				work_material_by_output_auth: 0,//是否开启【按报工权限控制领料权限】 - 只有有权限报工的人才能领料 1=开启 0=关闭
				task_start_auto: 0,		//是否开启【任务状态自动开始】1=开启 0=关闭
				task_end_auto: 1,		//是否开启【任务状态自动结束】1=开启 0=关闭
				material_process_method: 0, //外发发料方式，0:外发后手动前往委外单发料,1:外发后自动生成发料动态
				output_sort: 0,			//是否开启【限制报工顺序】1=开启 0=关闭
				output_count_limit: 0,	//是否开启【限制报工数量】1=开启 0=关闭
				distribute_count_limit: 0,	//是否开启【按分配数报工】1=开启 0=关闭
				auth_out_distribute: 0,	//是否开启【报工权限外分配】1=开启 0=关闭
				distribute_auth_priority:0,//是否开启【报工权限分配优先】1=开启 0=关闭
				assemble_work_sort:0,	//是否开启【限制装配工单完成顺序】1=开启 0=关闭
				auto_in_time_type:0,	//当工单任务开启自动入库配置时有效(0：报工后立即/1：报工记录审批后)生成成品入库单
				defects_salary:0,		//是否开启【不良品计算工资】，开启后，预计工资=(良品数+不良品数)*工资单价，否则预计工资=良品数*工资单价，1=开启 0=关闭
				
				order_deliver_auto_approval:0,//【订单发货】是否自动核准0：手动核准 1：自动核准
				quality_work_auto_approval:0,//【生产入库检】是否自动审批0：手动审批 1：自动审批
                stockin_auto_approval:0,//【入库单】是否自动审批 0：手动审批  1：自动审批
                stockout_auto_approval:0,//【出库单】是否自动审批 0：手动审批  1：自动审批
                inventory_auto_approval:0,//【盘点单】是否自动审批 0：手动审批  1：自动审批
				output_auto_approval:0,//【报工】是否自动审批0：手动审批 1：自动审批

				mobile_type:1,			//移动端优先打开方式（1：H5，2：小程序）
				check_stock:0,			//校验库存是否充足（1：开启，0：关闭）开启后，当库存不足时，无法完成库存扣减操作
				work_start_notice:0,	//是否开启【工单开始】通知 1=开启 0=关闭
				curr_output_notice:0,	//是否开启【报工处理通知】 1=开启 0=关闭
				next_output_notice:0,	//是否开启【前工序完工通知】通知 1=开启 0=关闭
				work_overdue_notice:0,  //是否开启【工单逾期】通知 1=开启 0=关闭
				work_overdue_notice_time_list:[0],  //【工单逾期】通知提前量
				task_overdue_notice:0,  //是否开启【任务逾期】通知 1=开启 0=关闭
				task_overdue_notice_time_list:[0],  //【工单逾期】通知提前量
				inventory_warning_notice:0  //是否开启【库存预警通知】通知 1=开启 0=关闭
			}
		},

		computed: {
			...mapState(['systemConfig', 'userInfo', 'saasInfo', 'openCloseDic', 'allowDisallowDic', 'materialProcessMethodDic', 'autoInTimeTypeDic', 'outputCountLimitTypeDic','mobileTypeDic']),
			...mapGetters(['freeEdition']),

			tabList() {
				let list = [];
				list.push({"value":1, "name": "基础信息"});
				list.push({"value":2, "name": "系统配置"});
				list.push({"value":3, "name": "通知配置"});
				return list;
			},
		},

		mounted() {
			//默认选中第一个选项卡
			this.$refs.tabList.changeIndex(0);
			this.update();
			//查询系统配置
			this.getSystemConfig();

			if (this.saasInfo.use_template_state == 2) {
				this.showTemplet();
			}
		},

		methods: {
			update() {
				this.request({
					url: '/sys_saas/detail',
					success: data => {
						this.dataInfo = data;
					},
					fail: (code, data, msg) => {
						if (code == 9200) {
							this.$confirm({
								message: msg,
								buttonName: '我知道了',
								cancelButton: false,
								resolve: () => {
									this.$store.commit('setSession', '');
									this.navigateTo('/login');
								}
							})
							return false;
						}
					}
				});
			},

			tabHandle(tab) {
				this.currentTab = tab.value;
			},

			editLogoHandle(remove) {
				new Promise(async resolve => {
					if (remove) {
						if (await this.$confirm({
							message: '确定要删除工厂LOGO吗？'
						}) == 'resolve') {
							resolve('');
						}
					} else {
						this.$upload({
							type: 'image',
							loading: true,
							success: data => {
								resolve(data[0].path);
							}
						});
					}
				}).then(data => {
					this.request({
						url: '/sys_saas/edit/logo',
						data: {
							saas_logo: data
						},
						loading: true,
						success: () => {
							this.$message({
								message: '修改成功'
							});
							this.update();
							this.$store.dispatch('updateLoginInfo');
						}
					});
				})
			},

			editNameHandle() {
				if (!this.editName.trim()) {
					this.$message({
						message: '工厂名称不能为空'
					});
					return;
				}
				this.request({
					url: '/sys_saas/edit/name',
					data: {
						saas_name: this.editName.trim()
					},
					loading: true,
					success: () => {
						this.$message({
							message: '修改成功'
						});
						this.dataInfo.saas_name = this.editName.trim();
						this.editName = false;
						this.$store.dispatch('updateLoginInfo');
					}
				});
			},

			renewalHandle() {
				if (this.freeEdition) {
					this.$refs.renewConfirm.open();
				} else {
					this.getSys().$refs.businessService.open();
				}
			},

			showTemplet() {
				this.request({
					url: '/sys_saas/templateList',
					loading: true,
					success: data => {
						this.templetList = data.map(item => {
							item.template_sub_title = item.template_sub_title ? item.template_sub_title.split('\n') : [];
							return item;
						});
						this.$refs.templetList.open();
					}
				});
			},

			templetHandle(item) {
				this._currentTemplet = item;
				this.currentApplyType = this.applyType[0].value;
				if (this.saasInfo.use_template_state == 2) {
					this.applyHandle(null, () => {
						this.navigateTo('/');
						this.getSys().aliveMenu = 'p_basic';
					});
				} else {
					this.$refs.applyType.open();
				}
			},

			async applyHandle(stop, next) {
				stop && stop();
				if (this.saasInfo.use_template_state == 2 || await this.$confirm({
					title: '确定要加载数据吗？',
					message: '加载后原有的所有数据会被覆盖且不可恢复，请谨慎操作'
				}) == 'resolve') {
					let loading = this.$loading({
						timeout: false
					});
					let progress = [
						'正在加载方案数据',
						'正在应用方案数据',
						'正在做最后的部署'
					];
					let timer;
					if (this._currentTemplet) {
						!function() {
							let start = 0,
								max = 99;
							let num = 0,
								gradient = max / 1200;
							
							!function loop() {
								if (num < max) {
									num += gradient;
									let index = num < 20 ? 0 : num < 80 ? 1 : 2;
									loading.update(`${progress[index]} (${parseInt(start + Math.min(num, max))}%)`);
									timer = setTimeout(() => {
										loop.call(this);
									}, 20);
								}
							}.call(this);
						}.call(this);
					}

					this.request({
						url: '/sys_saas/data/apply',
						data: {
							saas_id: this.userInfo.saas_id,
							from_saas_id: this._currentTemplet ? this._currentTemplet.saas_id : 0,
							apply_type: this._currentTemplet ? this.currentApplyType : 1
						},
						success: () => {
							this.$refs.templetList.close();
							this.$message({
								message: '操作成功'
							});
							next();
							this.getSystemConfig();
							this.$store.dispatch('updateLoginInfo');
						},
						complete: () => {
							clearTimeout(timer);
							loading.close();
						}
					});
				}
			},

			clearData() {
				this.currentClearType = this.clearType[0].value;
				this.$refs.clearType.open();
			},

			clearHandle(stop, next) {
				stop();
				this.$confirm({
					title: '确定要清空数据吗？',
					message: '清空后数据不可恢复，请谨慎操作',
					resolve: () => {
						this.request({
							url: '/sys_saas/data/clear',
							data: {
								saas_id: this.userInfo.saas_id,
								clear_type: this.currentClearType
							},
							loading: true,
							success: () => {
								this.$message({
									message: '操作成功'
								});
								next();
							}
						})
					}
				})
			},
			/****查询系统配置信息*****/
			getSystemConfig(){
				this.request({
					url: '/sys_saas/get/sys/config',
					success: data => {
						data.forEach(item => {
							if (item.config_item_code == 'mobile_type'){
								this.mobile_type = item.config_item_value||1;	
							}else if (item.config_item_code == 'check_stock'){
								this.check_stock = item.config_item_value||0;
							}else if (item.config_item_code == 'order_occ_start_auto'){
								this.order_occ_start_auto = item.config_item_value||0;
							}else if (item.config_item_code == 'order_end_auto'){
								this.order_end_auto = item.config_item_value||0;	
							}else if (item.config_item_code == 'order_default_deliver_count_type'){
								this.order_default_deliver_count_type = item.config_item_value||0;

							}else if( item.config_item_code == 'purchase_order_end_auto'){
								this.purchase_order_end_auto = item.config_item_value||0;

                            }else if (item.config_item_code == 'work_start_auto'){
								this.work_start_auto = item.config_item_value||0;
							}else if (item.config_item_code == 'work_end_auto'){
								this.work_end_auto = item.config_item_value||0;
							}else if (item.config_item_code == 'work_material_picking_limit'){
								this.work_material_picking_limit = item.config_item_value||0;
							}else if (item.config_item_code == 'work_material_by_output_auth'){
								this.work_material_by_output_auth = item.config_item_value||0;	
								
							}else if (item.config_item_code == 'task_start_auto'){
								this.task_start_auto = item.config_item_value||0;
							}else if (item.config_item_code == 'task_end_auto'){
								this.task_end_auto = item.config_item_value||0;
							}else if (item.config_item_code == 'material_process_method'){
								this.material_process_method = item.config_item_value||0;
								
							}else if (item.config_item_code == 'output_count_limit'){
								this.output_count_limit = item.config_item_value||0;
							}else if (item.config_item_code == 'distribute_count_limit'){
								this.distribute_count_limit = item.config_item_value||0;	
							}else if (item.config_item_code == 'output_sort'){
								this.output_sort = item.config_item_value||0;
							}else if (item.config_item_code == 'distribute_auth_priority'){
								this.distribute_auth_priority = item.config_item_value||0;
							}else if (item.config_item_code == 'assemble_work_sort'){
								this.assemble_work_sort = item.config_item_value||0;
							}else if (item.config_item_code == 'auto_in_time_type'){
								this.auto_in_time_type = item.config_item_value||0;
							}else if (item.config_item_code == 'defects_salary'){
								this.defects_salary = item.config_item_value||0;	
								
							}else if (item.config_item_code == 'work_start_notice'){
								this.work_start_notice = item.config_item_value||0;	
							}else if (item.config_item_code == 'curr_output_notice'){
								this.curr_output_notice = item.config_item_value||0;	
							}else if (item.config_item_code == 'next_output_notice'){
								this.next_output_notice = item.config_item_value||0;	
								
							}else if (item.config_item_code == 'work_overdue_notice'){
								this.work_overdue_notice = item.config_item_value||0;
							}else if (item.config_item_code == 'work_overdue_notice_time'){
								this.work_overdue_notice_time_list = item.config_item_value.split(",");
								
							}else if (item.config_item_code == 'task_overdue_notice'){
								this.task_overdue_notice = item.config_item_value||0;
							}else if (item.config_item_code == 'task_overdue_notice_time'){
								this.task_overdue_notice_time_list = item.config_item_value.split(",");
								
							}else if (item.config_item_code == 'inventory_warning_notice'){
								this.inventory_warning_notice = item.config_item_value||0;
								
							}else if (item.config_item_code == 'order_deliver_auto_approval'){//是否开启【订单发货】自动核准
							    this.order_deliver_auto_approval = item.config_item_value||0;	
							}else if (item.config_item_code == 'quality_work_auto_approval'){//是否开启【生产入库检】自动审批
                                this.quality_work_auto_approval = item.config_item_value||0;
                            }else if (item.config_item_code == 'stockin_auto_approval'){//是否开启【入库单】自动审批
                                this.stockin_auto_approval = item.config_item_value||0;
                            }else if (item.config_item_code == 'stockout_auto_approval'){//是否开启【出库单】自动审批
                                this.stockout_auto_approval = item.config_item_value||0;
                            }else if (item.config_item_code == 'inventory_auto_approval'){//是否开启【盘点单】自动审批
                                this.inventory_auto_approval = item.config_item_value||0;
                            }else if (item.config_item_code == 'output_auto_approval'){//是否开启【报工】自动审批
                                this.output_auto_approval = item.config_item_value||0;
                            }
						});
					}
				});
			},
			/**
			 * 添加通知配置
			 * @type 1= 工单通知
			 *       2= 任务通知
			 */
			addNoticeConfig(type){
				if (type == 1){
					this.work_overdue_notice_time_list.push(0);
				}else {
					this.task_overdue_notice_time_list.push(0);
				}
			},
			/**
			 * 保存系统配置
			 */
			submitSystemConfig() {
				this.$refs.systemConfigForm.submit({
					url: '/sys_saas/set/sys/config',
					rule: {
					},
					dataFormatter: data => {
						var system_config_list = [];
						
						var obj0 = {
							config_item_name:'订单自动占用库存',
							config_item_code:'order_occ_start_auto',
							config_item_type:7,
							config_item_value:this.order_occ_start_auto||0,
							config_item_remark: '新创建的订单默认库存占用状态为已占用'
						}
						
						var obj1 = {
							config_item_name:'订单自动完成',
							config_item_code:'order_end_auto',
							config_item_type:7,
							config_item_value:this.order_end_auto||0,
							config_item_remark: '当订单交货数>=已下单数时,订单状态变更为『已完成』'
						}
						
						var obj2 = {
							config_item_name:'订单默认发货数量填入规则',
							config_item_code:'order_default_deliver_count_type',
							config_item_type:7,
							config_item_value:this.order_default_deliver_count_type||0,
							config_item_remark: '按订单发货时，默认的发货数量填入规则，当考虑库存时，发货数不超过产品在库库存数'
						}
						
						var obj3 = {
							config_item_name:'新工单是否自动开始',
							config_item_code:'work_start_auto',
							config_item_type:7,
							config_item_value:this.work_start_auto||0,
							config_item_remark: '新创建的工单默认为开始状态'
						}
						
						var obj4 = {
							config_item_name:'工单是否自动结束',
							config_item_code:'work_end_auto',
							config_item_type:7,
							config_item_value:this.work_end_auto||0,
							config_item_remark: '当工单完工数>=工单计划数时,工单状态变更为『已结束』'
						}
						
						var obj5 = {
							config_item_name:'是否限制工单领料数量',
							config_item_code:'work_material_picking_limit',
							config_item_type:7,
							config_item_value:this.work_material_picking_limit||0,
							config_item_remark: '移动端工单在领料时,最大可领料数不允许超过物料的预计用量数'
						}
						
						var obj6 = {
							config_item_name:'是否按报工权限领料',
							config_item_code:'work_material_by_output_auth',
							config_item_type:7,
							config_item_value:this.work_material_by_output_auth||0,
							config_item_remark: '移动端工单在领料时，只有拥有该工序的报工权限时,才允许领取对应工序投料的物料'
						}
						
						var obj7 = {
							config_item_name:'任务是否自动开始',
							config_item_code:'task_start_auto',
							config_item_type:7,
							config_item_value:this.task_start_auto||0,
							config_item_remark: '工单开始后,任务工序自动开始'
						}
						
						var obj8 = {
							config_item_name:'任务是否自动结束',
							config_item_code:'task_end_auto',
							config_item_type:7,
							config_item_value:this.task_end_auto||0,
							config_item_remark: '当任务良品数>=任务计划数时,任务状态变更为『已结束』'
						}
						
						var obj9 = {
							config_item_name:'外发发料方式',
							config_item_code:'material_process_method',
							config_item_type:7,
							config_item_value:this.material_process_method||0,
							config_item_remark: '外发后手动前往委外单发料，外发后自动生成发料动态'
						}
						
						var obj10 = {
							config_item_name:'是否限制报工数量',
							config_item_code:'output_count_limit',
							config_item_type:7,
							config_item_value:this.output_count_limit||0,
							config_item_remark: '限制工序报工数量不能大于工单计划数*工序报工数配比'
						}
						var obj11 = {
							config_item_name:'按分配数报工',
							config_item_code:'distribute_count_limit',
							config_item_type:7,
							config_item_value:this.distribute_count_limit||0,
							config_item_remark: '开启后,如果分配数>0时,则按员工限制工序报工数量不能大于员工分配数量'
						}
						var obj12 = {
							config_item_name:'是否限制报工顺序',
							config_item_code:'output_sort',
							config_item_type:7,
							config_item_value:this.output_sort||0,
							config_item_remark: '生产报工数量不能超过上一道工序报工良品数'
						}
						
						var obj13 = {
							config_item_name:'报工权限分配优先',
							config_item_code:'distribute_auth_priority',
							config_item_type:7,
							config_item_value:this.distribute_auth_priority||0,
							config_item_remark: '存在分配人员，则只能分配人员进行报工'
						}
						
						var obj14 = {
							config_item_name:'限制装配工单完成顺序',
							config_item_code:'assemble_work_sort',
							config_item_type:7,
							config_item_value:this.assemble_work_sort||0,
							config_item_remark: '子装配工单未完成，不允许父装配工单报工'
						}
						
						var obj17 = {
							config_item_name:'报工自动入库时间',
							config_item_code:'auto_in_time_type',
							config_item_type:7,
							config_item_value:this.auto_in_time_type||0,
							config_item_remark: '当工单任务开启自动入库配置时有效，可配置为(报工后立即/报工审批后)生成成品入库单'
						}
						
						var obj18 = {
							config_item_name:'不良品计算工资',
							config_item_code:'defects_salary',
							config_item_type:7,
							config_item_value:this.defects_salary||0,
							config_item_remark: '开启后，预计工资=(良品数+不良品数)*工资单价，否则预计工资=良品数*工资单价'
						}

						var obj19 = {
							config_item_name:'是否开启【订单发货】自动核准',
							config_item_code:'order_deliver_auto_approval',
							config_item_type:7,
							config_item_value:this.order_deliver_auto_approval||0,
							config_item_remark: '开启自动核准后，订单发货自动完成核准'
						}

						var obj20 = {
							config_item_name:'是否开启【生产入库检验单】自动审批',
							config_item_code:'quality_work_auto_approval',
							config_item_type:7,
							config_item_value:this.quality_work_auto_approval||0,
							config_item_remark: '开启自动审批后，生产入库检验单自动完成审批'
						}

						var obj21 = {
							config_item_name:'是否开启【入库单】自动审批',
							config_item_code:'stockin_auto_approval',
							config_item_type:7,
							config_item_value:this.stockin_auto_approval||0,
							config_item_remark: '开启自动审批后，入库单自动完成审批'
						}

						var obj22 = {
							config_item_name:'是否开启【出库单】自动审批',
							config_item_code:'stockout_auto_approval',
							config_item_type:7,
							config_item_value:this.stockout_auto_approval||0,
							config_item_remark: '开启自动审批后，出库单自动完成审批'
						}

						var obj23 = {
							config_item_name:'是否开启【盘点单】自动审批',
							config_item_code:'inventory_auto_approval',
							config_item_type:7,
							config_item_value:this.inventory_auto_approval||0,
							config_item_remark: '开启审批后，盘点单自动完成审批'
						}
						
						var obj24 = {
							config_item_name:'是否开启【报工】自动审批',
							config_item_code:'output_auto_approval',
							config_item_type:7,
							config_item_value:this.output_auto_approval||0,
							config_item_remark: '开启审批后，员工报工后，报工记录自动完成审批'
						}
						var obj25 = {
							config_item_name:'移动端优先打开方式',
							config_item_code:'mobile_type',
							config_item_type:7,
							config_item_value:this.mobile_type,
							config_item_remark: '移动端优先打开方式（1：H5，2：小程序）'
						}
						var obj26 = {
							config_item_name:'校验库存是否充足',
							config_item_code:'check_stock',
							config_item_type:7,
							config_item_value:this.check_stock,
							config_item_remark: '开启后，当库存不足时，无法完成库存扣减操作'
						}
                        var obj27 = {
							config_item_name:'采购单自动完成',
							config_item_code:'purchase_order_end_auto',
							config_item_type:7,
							config_item_value:this.purchase_order_end_auto ||0,
							config_item_remark: '当采购单收货数>=采购数时,采购单状态变更为『已完成』'
						}

						system_config_list.push(obj0);
						system_config_list.push(obj1);
						system_config_list.push(obj2);
						system_config_list.push(obj3);
						system_config_list.push(obj4);
						system_config_list.push(obj5);
						system_config_list.push(obj6);
						system_config_list.push(obj7);
						system_config_list.push(obj8);
						system_config_list.push(obj9);
						system_config_list.push(obj10);
						system_config_list.push(obj11);
						system_config_list.push(obj12);
						system_config_list.push(obj13);
						system_config_list.push(obj14);
						system_config_list.push(obj17);
						system_config_list.push(obj18);
						system_config_list.push(obj19);
						system_config_list.push(obj20);
						system_config_list.push(obj21);
						system_config_list.push(obj22);
						system_config_list.push(obj23);
						system_config_list.push(obj24);
						system_config_list.push(obj25);
						system_config_list.push(obj26);
                        system_config_list.push(obj27);
						return {
							system_config_list:system_config_list
						};
					},
					success: () => {
						this.$message({
							message: '配置成功'
						});
                        //更新全局配置
                        this.$store.dispatch('updateSystemConfig');  // 更新配置
					}
				});
			},
			
			/**
			 * 保存通知配置
			 */
			submitNoticeConfig() {
				var submitFlag = true;
				if (this.work_overdue_notice == 1){
					if(this.work_overdue_notice_time_list.length == 0){
						submitFlag = false;
						this.$message({
							message: '请添加工单逾期通知时间配置',
							type: 'warn'
						});
					}
					let uniqueArr = this.work_overdue_notice_time_list.filter((value, index, self) => {
						return self.indexOf(value) === index;
					});
					if (uniqueArr.length != this.work_overdue_notice_time_list.length){
						submitFlag = false;
						this.$message({
							message: '【工单逾期通知】两次通知的时间不允许相同',
							type: 'warn'
						});
					}
				}
				if (this.task_overdue_notice == 1){
					if(this.task_overdue_notice_time_list.length == 0){
						submitFlag = false;
						this.$message({
							message: '请添加任务逾期通知时间配置',
							type: 'warn'
						});
					}
					let uniqueArr = this.task_overdue_notice_time_list.filter((value, index, self) => {
						return self.indexOf(value) === index;
					});
					if (uniqueArr.length != this.task_overdue_notice_time_list.length){
						submitFlag = false;
						this.$message({
							message: '【任务逾期通知】两次通知的时间不允许相同',
							type: 'warn'
						});
					}
				}
				if (submitFlag){
					this.$refs.noticeConfigForm.submit({
						url: '/sys_saas/set/sys/config',
						rule: {
						},
						dataFormatter: data => {
							data.work_overdue_notice = this.work_overdue_notice||0;
							data.task_overdue_notice = this.task_overdue_notice||0;
							data.inventory_warning_notice = this.inventory_warning_notice||0;
							//排序，数字大的排前面
							this.work_overdue_notice_time_list.sort(function(a, b){return b-a});
							this.task_overdue_notice_time_list.sort(function(a, b){return b-a});
							data.work_overdue_notice_time = this.work_overdue_notice==0?'0':this.work_overdue_notice_time_list.join(",");
							data.task_overdue_notice_time = this.task_overdue_notice==0?'0':this.task_overdue_notice_time_list.join(",");
							return this.handleSubmitData(data);
						},
						success: () => {
							this.$message({
								message: '配置成功'
							});
							//更新全局配置
							this.$store.dispatch('updateSystemConfig');  // 更新配置
						}
					});
				}
			},
			//构造提交数据
			handleSubmitData(data){
				/***********拼装最终的返回数据********/
				var system_config_list = [];
				
				var obj1 = {
					config_item_name:'是否开启【工单开始】通知',
					config_item_code:'work_start_notice',
					config_item_type:7,
					config_item_value:this.work_start_notice,
					config_item_remark: '开启后，工单开始时会通知拥有工单第一道工序报工权限的管理员'
				}
				var obj2 = {
					config_item_name:'是否开启【报工处理通知】通知',
					config_item_code:'curr_output_notice',
					config_item_type:7,
					config_item_value:this.curr_output_notice,
					config_item_remark: '开启后，工序任务报工后，将通知拥有当前任务报工权限的管理员'
				}
				var obj3 = {
					config_item_name:'是否开启【前工序完工通知】通知',
					config_item_code:'next_output_notice',
					config_item_type:7,
					config_item_value:this.next_output_notice,
					config_item_remark: '开启后，前工序任务报工后，通知拥有下一道工序报工权限的管理员'
				}
				var obj4 = {
					config_item_name:'是否开启【工单逾期】通知',
					config_item_code:'work_overdue_notice',
					config_item_type:7,
					config_item_value:this.work_overdue_notice,
					config_item_remark: '工单逾期前将按设置的频率发送通知'
				}
				var obj5 = {
					config_item_name:'【工单逾期】通知时间',
					config_item_code:'work_overdue_notice_time',
					config_item_type:1,
					config_item_value:data.work_overdue_notice_time,
					config_item_remark:'表示逾期前几小时通知，多个时间表示通知多次，多个时间之间以英文逗号分隔'
				}
				var obj6 = {
					config_item_name:'是否开启【任务逾期】通知',
					config_item_code:'task_overdue_notice',
					config_item_type:7,
					config_item_value:this.task_overdue_notice,
					config_item_remark: '任务逾期前将按设置的频率发送通知'
				}
				var obj7 = {
					config_item_name:'【任务逾期】通知时间',
					config_item_code:'task_overdue_notice_time',
					config_item_type:1,
					config_item_value:data.task_overdue_notice_time,
					config_item_remark:'表示逾期前几小时通知，多个时间表示通知多次，多个时间之间以英文逗号分隔'
				}
				var obj8 = {
					config_item_name:'是否开启【库存预警】通知',
					config_item_code:'inventory_warning_notice',
					config_item_type:7,
					config_item_value:this.inventory_warning_notice,
					config_item_remark: '开启库存预警通知后，仓库商品库存不足或者库存超限，将给相应的仓库管理员发送微信公众号通知，每日早8点发送警告通知，每天最多通知一次'
				}
				system_config_list.push(obj1);
				system_config_list.push(obj2);
				system_config_list.push(obj3);
				system_config_list.push(obj4);
				system_config_list.push(obj5);
				system_config_list.push(obj6);
				system_config_list.push(obj7);
				system_config_list.push(obj8);
				return {
					system_config_list:system_config_list
				};
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.factory {
		border: 1px solid var(--unit-line);
		border-radius: 0 10px 10px 10px;
		border-top: none;
		padding: 26px;
		margin: 0 15px 15px;
		overflow: auto;
		background: #fff;

		&-tab {
			margin: 0 15px;

			>>> ul {
				padding-left: 0;
			}
		}

		&-logo {
			margin-right: 28px;

			&-image {
				position: relative;
				width: 100px;
				height: 100px;
				font-size: 24px;
				color: #ccc;
				background: #242738;

				&:hover {
					color: var(--color-main);

					.factory-logo-handle {
						display: flex;
					}
				}
			}

			&-handle {
				gap: 20px;
				display: none;
				position: absolute;
				inset: 0;
				font-size: 20px;
				color: #fff;
				background: rgba(0,0,0,.6);

				a {
					font-size: 20px;

					&:hover {
						color: var(--color-main);
					}
				}
			}

			&-name {
				gap: 5px;
				margin-top: 10px;
				font-size: 13px;
				color: #666;
			}
		}

		&-name {
			height: 32px;
			gap: 12px;

			p {
				font-size: 22px;
				font-weight: bold;
			}

			a {
				font-size: 20px;
				color: var(--color-main);
			}

			input {
				box-sizing: border-box;
				width: 200px;
				height: 100%;
				border: 1px solid #ccc;
				padding: 0 10px;

				&:focus {
					border-color: var(--color-main);
				}
			}

			>>> .c-button {
				height: 32px !important;
			}
		}

		&-code {
			display: inline-block;
			border: 1px solid #ddd;
			border-radius: 15px;
			padding: 0 16px;
			margin-top: 10px;
			line-height: 28px;
			font-size: 14px;
		}

		&-info {
			margin-top: 34px;

			td {
				height: 36px;
				font-size: 14px;

				&:nth-child(1) {
					color: #666;
				}

				&:nth-child(2) {
					padding-left: 20px;
				}

				.edition {
					border-radius: 4px;
					padding: 0 8px;
					margin-right: 10px;
					line-height: 24px;
					font-size: 13px;
					color: #fff;
					background: #F5F5F5;
				}

				.tag {
					border-radius: 4px;
					padding: 0 12px;
					margin: 0 10px;
					line-height: 26px;
					font-size: 15px;
					font-weight: bold;
					background: #F5F5F5;

					span {
						color: var(--color-main);
					}
				}
			}
		}

		&-handle {
			gap: 20px;
			margin-top: 20px;
			
			>>> .c-button {
				border-radius: 4px;
			}
		}
	}

	.templet-list {
		gap: 20px;
		box-sizing: border-box;
		padding: 20px;

		.item {
			width: 300px;
			border-radius: 6px;
			overflow: hidden;
			background: #F9F9F9;
			transition: box-shadow .3s ease;

			&:hover {
				box-shadow: 0 0 10px 2px rgba(0,0,0,.1);
			}

			.cover {
				height: 200px;
				overflow: hidden;

				.image {
					height: 100%;
					background-size: cover;
					background-position: center;
					transition: transform .3s ease;

					^[-2]:hover ^[-2..-1] {
						transform: scale(1.2);
					}
				}
			}

			.info {
				padding: 6px 25px 0;

				h5 {
					line-height: 50px;
					font-size: 18px;
				}

				ul {
					li {
						position: relative;
						padding: 6px 0 6px 24px;
						line-height: 20px;
						font-size: 14px;
						color: #666;

						.tf {
							position: absolute;
							left: 0;
							top: 0;
							line-height: 32px;
							font-size: 15px;
							color: var(--color-main);
						}
					}
				}
			}

			.button {
				padding: 16px 0 20px;

				>>> .c-button {
					width: 108px;
					height: 36px !important;
				}
			}
		}
	}

	.data-type {
		gap: 15px;
		padding: 20px;

		li {
			position: relative;
			border: 1px solid #F5F5F5;
			border-radius: 4px;
			padding: 20px;
			background: #F5F5F5;
			cursor: pointer;

			h5 {
				margin-bottom: 14px;
				font-size: 16px;
				font-weight: normal;
			}

			p {
				line-height: 22px;
			}

			&.z-crt,
			&:hover {
				border-color: var(--color-main);
				background: #fff;
			}

			&.z-crt {
				&:before {
					content: '';
					position: absolute;
					right: 0;
					top: 0;
					border-top: 24px solid var(--color-main);
					border-left: 28px solid rgba(0,0,0,0);
				}

				&:after {
					content: '\e63f';
					position: absolute;
					right: 2px;
					top: 2px;
					font-family: 'cms_font';
					font-size: 10px;
					color: #fff;
				}
			}
		}
	}

	.notice {
		&-delete {
			padding: 5px;
			font-size: 15px;
			color: #f00;

			&:hover {
				border-radius: 4px;
				background: #F5F5F5;
			}
		}

		&-temp {
			height: 520px;

			&-tip {
				margin-left: 20px;
			}
		}

		&-guide {
			align-self: flex-start;
			position: sticky;
			top: 0;
			padding: 26px 30px 20px;
			background: #FAFAFA;

			&-tip {
				margin-bottom: 12px;
				font-size: 13px;
				color: #f55;
			}

			&-arrow {
				position: relative;
				width: 60px;
				height: 1px;
				margin: 90px 16px 0;
				background: #999;

				&:after {
					content: '';
					position: absolute;
					right: 0;
					top: -5px;
					border-left: 10px solid #999;
					border-top: 5px solid rgba(0,0,0,0);
					border-bottom: 5px solid rgba(0,0,0,0);
				}
			}

			&-item {
				width: 180px;

				img {
					height: 180px;
				}

				p {
					margin: 14px 0 10px;
					font-size: 14px;
					font-weight: bold;
					white-space: nowrap;
					color: #f55;
				}

				span {
					line-height: 20px;
					font-size: 13px;
					color: #999;
				}
			}
		}
	}
</style>